import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import EyeSection from "./EyeSection";

const OD_FIELDS = ["od_esf", "od_cil", "od_eixo", "od_adicao", "dnp_od", "altura_od"];
const OE_FIELDS = ["oe_esf", "oe_cil", "oe_eixo", "oe_adicao", "dnp_oe", "altura_oe"];

export default function ReceitaLaboratorio({ register }) {
  return (
    <>
      <div>
        <h3 className="text-lg font-semibold text-slate-900 border-b border-slate-200 pb-2 mb-4">Laboratorio e Lente</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="space-y-2">
            <Label htmlFor="nome_laboratorio" className="text-sm font-medium text-slate-700">Nome do Laboratorio</Label>
            <Input id="nome_laboratorio" {...register("nome_laboratorio")} placeholder="Nome do laboratorio" data-testid="input-nome-laboratorio" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="tipo_lente" className="text-sm font-medium text-slate-700">Tipo de Lente</Label>
            <Input id="tipo_lente" {...register("tipo_lente")} placeholder="Ex: Multifocal, Monofocal" data-testid="input-tipo-lente" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="valor_lente" className="text-sm font-medium text-slate-700">Valor da Lente (R$)</Label>
            <Input id="valor_lente" type="number" step="0.01" {...register("valor_lente")} placeholder="0.00" data-testid="input-valor-lente" />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <EyeSection side="OD" label="Olho Direito" color="blue" register={register}
          fields={OD_FIELDS} />
        <EyeSection side="OE" label="Olho Esquerdo" color="green" register={register}
          fields={OE_FIELDS} />
      </div>
    </>
  );
}
